@if (isLoading) {
  <div class="loading-state">Loading user data…</div>
} @else if (user) {
  <div class="breadcrumbs">
    <button class="back-button" (click)="cancel()">
      <mat-icon>arrow_back_ios</mat-icon>
      <span class="breadcrumb-text">CQMS Users</span>
    </button>
    <div class="slash">/</div>
    <span class="breadcrumb-text"
      >{{ user.firstName }} {{ user.lastName }}</span
    >
  </div>

  <content-panel>
    <panel-body>
      <div class="container-row">
        <!-- Left: read-only user info -->
        <div class="container-left">
          <div class="section-title">CQMS User Information</div>
          <div class="info-panel-body">
            <div class="info-field">
              <span class="info-label">First Name</span>
              <span class="info-value">{{ user.firstName }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Last Name</span>
              <span class="info-value">{{ user.lastName }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Email</span>
              <span class="info-value">{{ user.email }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">Plant</span>
              <span class="info-value"
                >{{ user.plantName || '—' }} ({{ user.plantNumber }})</span
              >
            </div>
          </div>
        </div>

        <!-- Right: zone picker -->
        <div class="container-right">
          <div class="section-title">Zone Assignment</div>
          <div class="drag-drop-row">
            <!-- Unassigned column -->
            <div class="drag-drop-container">
              <div class="drag-drop-titles">
                <span>Unassigned Zones</span>
                <span class="count-badge">{{ unassignedZones.length }}</span>
              </div>
              <div class="example-list">
                @for (zone of unassignedZones; track zone.id) {
                  <div
                    class="example-box"
                    (click)="moveToAssigned(zone)"
                    role="button"
                    tabindex="0"
                    (keydown.enter)="moveToAssigned(zone)"
                    (keydown.space)="moveToAssigned(zone)"
                  >
                    <span class="item-name-text">{{ zone.name }}</span>
                    <mat-icon class="assign-icon">chevron_right</mat-icon>
                  </div>
                } @empty {
                  <div class="empty-dept-text">All zones assigned</div>
                }
              </div>
            </div>

            <!-- Assigned column -->
            <div class="drag-drop-container">
              <div class="drag-drop-titles">
                <span>Assigned Zones</span>
                <span class="count-badge assigned">{{
                  assignedZones.length
                }}</span>
              </div>
              <div class="example-list">
                @for (zone of assignedZones; track zone.id) {
                  <div
                    class="example-box assigned-item"
                    (click)="moveToUnassigned(zone)"
                    role="button"
                    tabindex="0"
                    (keydown.enter)="moveToUnassigned(zone)"
                    (keydown.space)="moveToUnassigned(zone)"
                  >
                    <mat-icon class="unassign-icon">chevron_left</mat-icon>
                    <span class="item-name-text">{{ zone.name }}</span>
                  </div>
                } @empty {
                  <div class="empty-dept-text">No zones assigned</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (saveError) {
        <div class="save-error">{{ saveError }}</div>
      }

      <div class="button-row">
        <button
          mat-flat-button
          type="button"
          (click)="cancel()"
          class="cancel-button"
        >
          Cancel
        </button>
        <button
          mat-flat-button
          type="button"
          (click)="save()"
          [disabled]="!hasFormChanged"
          class="save-button"
        >
          Save
        </button>
      </div>
    </panel-body>
  </content-panel>
}
